var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParentChild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-parents",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-parents:not(.animated) .animable {opacity: 0;}svg#freepik_stories-parents.animated #freepik--Clouds--inject-74 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-parents.animated #freepik--Trees--inject-74 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}svg#freepik_stories-parents.animated #freepik--Plants--inject-74 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}            @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-74",
    className: "animable",
    style: {
      transformOrigin: "252.785px 257.368px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.42,406.72c20.94-11.5,39.18-26.67,52.28-49.38,15-26,23.84-57.73,26.57-87.6,5.55-60.57-21-120.27-63.59-162.6a219.93,219.93,0,0,0-56.53-40.91C321,45.16,291.07,72.52,254,88.57c-46.27,20-88.32-22.09-133.26-26.41C61.78,56.48,16.65,115.74,22,171.37c4,41.65,43.64,74.39,45.62,107.12S29.88,333,29.88,380.65c0,24.91,31.33,42.78,50.43,51.84,43,20.39,92.66,25.56,139.65,23.12C282.11,452.38,349.54,436.86,404.42,406.72Z",
    style: {
      fill: "#455FC0",
      transformOrigin: "252.785px 257.368px"
    },
    id: "elk4y87wdfmrr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwo4gwpilp5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.42,406.72c20.94-11.5,39.18-26.67,52.28-49.38,15-26,23.84-57.73,26.57-87.6,5.55-60.57-21-120.27-63.59-162.6a219.93,219.93,0,0,0-56.53-40.91C321,45.16,291.07,72.52,254,88.57c-46.27,20-88.32-22.09-133.26-26.41C61.78,56.48,16.65,115.74,22,171.37c4,41.65,43.64,74.39,45.62,107.12S29.88,333,29.88,380.65c0,24.91,31.33,42.78,50.43,51.84,43,20.39,92.66,25.56,139.65,23.12C282.11,452.38,349.54,436.86,404.42,406.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "252.785px 257.368px"
    },
    className: "animable",
    id: "el1y5v2xr8sql"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-74",
    className: "animable",
    style: {
      transformOrigin: "249.644px 107.392px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.2,164.74c-6.17-3.37-9-.57-11.22-3.37s6.17-10.1-10.67-17.4c0,0-1.12-15.71-24.13-16.27s-16.83,15.71-23,19.64-7.85-2.25-14,1.68-3.36,11.79-8.41,12.91-11.79-5.05-18-1.12-6.18,7.29-9,7.29-8.42-2.24-11.79,0-7.29,5.05-7.29,5.05h142S185.37,168.1,179.2,164.74Z",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "112.794px 150.418px"
    },
    id: "elrisym64hib",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.21,162.43a19.48,19.48,0,0,1-2.51,1.18",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "93.955px 163.02px"
    },
    id: "elx0eio9dsi8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.58,136.21a9.61,9.61,0,0,0-5.48,6.85c-1,5.14-3.42,8.57-6.16,8.91s-13-.69-14.73,3.08a15.13,15.13,0,0,0-1,3.44",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "111.895px 147.35px"
    },
    id: "el38xyl5xj15p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.73,130.42c-3-1.65-4.4-.28-5.5-1.65s3-5-5.22-8.52c0,0-.55-7.7-11.81-8S292,120,288.93,121.9s-3.85-1.1-6.87.82-1.65,5.77-4.12,6.32-5.78-2.47-8.8-.55-3,3.58-4.4,3.58-4.12-1.1-5.77,0-3.57,2.47-3.57,2.47h69.53S325.75,132.07,322.73,130.42Z",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "290.216px 123.391px"
    },
    id: "el0w1lfq9562l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.6,129.29a9.65,9.65,0,0,1-1.23.58",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "280.985px 129.58px"
    },
    id: "elwes8pqus8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.47,116.45a4.69,4.69,0,0,0-2.68,3.35c-.5,2.52-1.68,4.2-3,4.36s-6.37-.33-7.21,1.51a7.82,7.82,0,0,0-.47,1.69",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "289.79px 121.905px"
    },
    id: "elc1wcl0kkagv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.58,97.31c-2.33-1.28-3.39-.22-4.23-1.28s2.32-3.81-4-6.56c0,0-.42-5.92-9.1-6.14s-6.35,5.93-8.68,7.41-3-.84-5.29.64-1.27,4.44-3.17,4.87-4.45-1.91-6.78-.43-2.32,2.75-3.38,2.75-3.18-.84-4.45,0-2.75,1.91-2.75,1.91h53.55S438.91,98.57,436.58,97.31Z",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "411.561px 91.9021px"
    },
    id: "elh9hdsnx36a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.9,96.44a7.74,7.74,0,0,1-.94.44",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "404.43px 96.66px"
    },
    id: "elkkszej2lgzs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.36,86.55a3.6,3.6,0,0,0-2.07,2.58c-.39,1.94-1.29,3.23-2.33,3.36s-4.9-.26-5.55,1.16a5.37,5.37,0,0,0-.36,1.3",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "411.205px 90.75px"
    },
    id: "elhmojndpofjk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 399.54,
    y1: 95.97,
    x2: 403.25,
    y2: 95.97,
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "401.395px 95.97px"
    },
    id: "elstx1kwj242",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.35,96h25s2-6-5.37-10.06-10.73-.67-13.41-4S446,69.81,425.86,61.1c0,0-1.34-18.78-28.84-19.45s-20.12,18.78-27.5,23.47-9.39-2.68-16.76,2-4,14.09-10.06,15.43-14.09-6-21.46-1.34-7.38,8.71-10.73,8.71-10.06-2.68-14.09,0-8.72,6-8.72,6H395.3",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "372.649px 68.8165px"
    },
    id: "elr4tr7l4a8i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.64,83.15a24.39,24.39,0,0,1-3,1.42",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "350.14px 83.86px"
    },
    id: "eluim25gmr7v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.28,78.45a17.68,17.68,0,0,1,1.14-4.11c2.05-4.5,14.33-3.28,17.6-3.69s6.14-4.5,7.37-10.64a11.44,11.44,0,0,1,6.55-8.18",
    style: {
      fill: "none",
      stroke: "rgb(146, 152, 155)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "371.61px 65.14px"
    },
    id: "elwwrnsszdh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-74",
    className: "animable",
    style: {
      transformOrigin: "299.675px 248.665px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.67,190.8s26.27-13.13,47.6,7.39l.86.79a74.49,74.49,0,0,0,28.69-58.65c0-41.47-34.17-75.09-76.33-75.09s-76.32,33.62-76.32,75.09A74.52,74.52,0,0,0,162,199.11C166.8,195.59,189,180.61,208.67,190.8Z",
    style: {
      fill: "#455FC0",
      transformOrigin: "209.495px 132.175px"
    },
    id: "el73zhs6z1yvb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els0jdmtdf29b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.67,190.8s26.27-13.13,47.6,7.39l.86.79a74.49,74.49,0,0,0,28.69-58.65c0-41.47-34.17-75.09-76.33-75.09s-76.32,33.62-76.32,75.09A74.52,74.52,0,0,0,162,199.11C166.8,195.59,189,180.61,208.67,190.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "209.495px 132.175px"
    },
    className: "animable",
    id: "elvc5cgrlplvo"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "182.31 174.76 207.38 183.17 206.17 432.09 212.4 432.09 211.04 171.54 230.44 160.76 258.25 163.9 233.35 159.15 263.92 142.16 245.19 151.32 248 142.43 260.61 132.47 248.8 139.88 252.34 128.69 244.07 148.63 237.13 140.24 241 127.27 235.93 138.79 227.77 128.93 243.06 151.06 242.38 152.69 210.95 168.06 210.19 138.38 219.57 127.55 247.15 120.42 235.95 122.36 241.24 116.41 233.83 122.72 221.98 124.77 235.57 109.08 224.79 119.47 225.64 106.25 223.1 121.1 210.07 133.65 209.49 111.19 209.1 124.67 204.41 116.7 206.19 107.06 216.19 97.5 206.71 104.28 209.58 88.76 202.89 114.12 196.58 103.41 200.89 112.02 189.96 108.61 202.1 114.45 209 128.24 208.35 150.09 193.86 138.92 190.25 129.96 191.85 116.64 189.02 126.8 189.23 127.43 182.88 111.68 191.81 137.33 178.15 126.8 195.37 142.35 169.41 140.74 183.63 142.78 166.1 147.59 187.2 143.28 198.13 144.85 208.24 153.97 207.51 178.88 190.49 175.08 174.37 155.16 182.93 167.22 163.03 162.25 185.22 170.46 188.13 174.56 168.94 170.28 179.02 173.66 159.01 178.31 182.31 174.76",
    style: {
      fill: "rgb(194, 194, 194)",
      transformOrigin: "211.465px 260.425px"
    },
    id: "elhs9retoodu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,339.51s15.37-7.69,27.86,4.33l.5.46A43.59,43.59,0,0,0,466.18,310c0-24.27-20-44-44.68-44s-44.69,19.69-44.69,44a43.63,43.63,0,0,0,16.9,34.42C396.5,342.31,409.51,333.55,421,339.51Z",
    style: {
      fill: "#455FC0",
      transformOrigin: "421.495px 305.21px"
    },
    id: "elx263kh47pj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpbfw3taf9v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421,339.51s15.37-7.69,27.86,4.33l.5.46A43.59,43.59,0,0,0,466.18,310c0-24.27-20-44-44.68-44s-44.69,19.69-44.69,44a43.63,43.63,0,0,0,16.9,34.42C396.5,342.31,409.51,333.55,421,339.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "421.495px 305.21px"
    },
    className: "animable",
    id: "elflgfufs5ou"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "405.58 330.12 420.26 335.05 420.04 431.4 422.68 431.4 422.4 328.24 433.76 321.93 450.04 323.76 435.46 320.98 453.36 311.04 442.39 316.4 444.04 311.2 451.42 305.37 444.51 309.7 446.58 303.15 441.74 314.82 437.68 309.92 439.94 302.32 436.98 309.07 432.2 303.29 441.15 316.25 440.75 317.2 422.35 326.2 421.9 308.82 427.4 302.48 443.54 298.31 436.98 299.44 440.08 295.96 435.75 299.66 428.81 300.86 436.76 291.67 430.45 297.75 430.95 290.01 429.46 298.71 421.83 306.06 421.5 292.91 421.26 300.8 418.52 296.13 419.56 290.49 425.42 284.89 419.87 288.86 421.55 279.77 417.63 294.62 413.94 288.35 416.46 293.39 410.06 291.39 417.17 294.82 421.2 302.89 420.83 315.68 412.35 309.14 410.23 303.89 411.17 296.1 409.51 302.05 409.63 302.41 405.91 293.19 411.14 308.21 403.15 302.05 413.23 311.15 398.03 310.21 406.36 311.4 396.09 314.22 408.44 311.69 414.85 312.61 420.76 317.95 420.33 332.53 410.37 330.31 400.93 318.64 405.94 325.71 394.29 322.8 407.29 327.6 408.99 330 397.75 327.5 403.65 329.48 391.94 332.2 405.58 330.12",
    style: {
      fill: "rgb(194, 194, 194)",
      transformOrigin: "422.65px 355.585px"
    },
    id: "elb5mqae6pwhr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.86,270.84s17.55-8.78,31.81,4.93c.19.19.38.35.57.53a49.77,49.77,0,0,0,19.17-39.19c0-27.72-22.84-50.19-51-50.19s-51,22.47-51,50.19a49.81,49.81,0,0,0,19.28,39.28C275.87,274,290.72,264,303.86,270.84Z",
    style: {
      fill: "#455FC0",
      transformOrigin: "304.41px 231.655px"
    },
    id: "elfbaajr9evos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwqxrugoy4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.86,270.84s17.55-8.78,31.81,4.93c.19.19.38.35.57.53a49.77,49.77,0,0,0,19.17-39.19c0-27.72-22.84-50.19-51-50.19s-51,22.47-51,50.19a49.81,49.81,0,0,0,19.28,39.28C275.87,274,290.72,264,303.86,270.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "304.41px 231.655px"
    },
    className: "animable",
    id: "elyqqyple6dq"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "286.24 260.12 303 265.74 302.18 432.09 306.35 432.09 305.44 257.96 318.4 250.76 336.99 252.86 320.35 249.68 340.78 238.33 328.26 244.45 330.14 238.51 338.57 231.86 330.68 236.81 333.04 229.33 327.51 242.65 322.88 237.05 325.46 228.38 322.07 236.08 316.62 229.49 326.84 244.28 326.38 245.37 305.38 255.64 304.87 235.8 311.14 228.56 329.57 223.8 322.08 225.09 325.62 221.12 320.67 225.34 312.75 226.71 321.83 216.22 314.63 223.16 315.2 214.33 313.5 224.25 304.79 232.64 304.4 217.63 304.14 226.64 301.01 221.32 302.2 214.87 308.88 208.49 302.54 213.01 304.46 202.64 299.99 219.59 295.77 212.43 298.65 218.19 291.35 215.91 299.46 219.81 304.07 229.03 303.64 243.63 293.96 236.16 291.54 230.17 292.62 221.28 290.72 228.07 290.86 228.48 286.62 217.96 292.58 235.1 283.46 228.07 294.96 238.46 277.61 237.38 287.12 238.74 275.4 241.96 289.5 239.08 296.81 240.13 303.57 246.22 303.08 262.87 291.7 260.33 280.93 247.01 286.65 255.08 273.35 251.75 288.18 257.24 290.13 259.98 277.3 257.12 284.04 259.38 270.67 262.49 286.24 260.12",
    style: {
      fill: "rgb(194, 194, 194)",
      transformOrigin: "305.725px 317.365px"
    },
    id: "elvw809pg34q",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-74",
    className: "animable",
    style: {
      transformOrigin: "409.875px 397.23px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.75,431.61a.39.39,0,0,1-.4-.39V380.05a.4.4,0,0,1,.4-.39.39.39,0,0,1,.39.39v51.17A.38.38,0,0,1,410.75,431.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.745px 405.635px"
    },
    id: "el2nmxex8iijh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,426.6a21.88,21.88,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S398.05,430.06,410.36,426.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.67px 423.088px"
    },
    id: "elmjgg6xey8fj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,426.6a21.88,21.88,0,0,1,6.15-5.77c3.46-1.92,9.24-1.92,9.24-1.92S423.06,430.06,410.75,426.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.445px 423.088px"
    },
    id: "elhtflk6pvg5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,412.75a22,22,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S398.05,416.21,410.36,412.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.67px 409.238px"
    },
    id: "elddbso6ovunk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,412.75A22,22,0,0,1,416.9,407c3.46-1.92,9.24-1.92,9.24-1.92S423.06,416.21,410.75,412.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.445px 409.248px"
    },
    id: "elnuwke3gda3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,398.9a22,22,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S398.05,402.37,410.36,398.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.67px 395.389px"
    },
    id: "elrwm2b4vcsx8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,398.9a22,22,0,0,1,6.15-5.77c3.46-1.92,9.24-1.92,9.24-1.92S423.06,402.37,410.75,398.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.445px 395.389px"
    },
    id: "el83497bda7j4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,385.05a22,22,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S398.05,388.52,410.36,385.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "402.67px 381.539px"
    },
    id: "el9lzbodnc0p4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,385.05a22,22,0,0,1,6.15-5.77c3.46-1.92,9.24-1.92,9.24-1.92S423.06,388.52,410.75,385.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "418.445px 381.539px"
    },
    id: "elacva2nwwrhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.75,380.05s-3.08-4.14-3.24-8.1,2.45-9.1,2.45-9.1S419.39,370.63,410.75,380.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.949px 371.45px"
    },
    id: "elvjthn7ocd4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,431.39V408.11a.39.39,0,0,0-.78,0v23.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.61px 419.555px"
    },
    id: "elr3co6jv2t9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.18,427a22,22,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S363.87,430.42,376.18,427Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.49px 423.482px"
    },
    id: "elc09ly5in91c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,427a22,22,0,0,1,6.15-5.77c3.47-1.92,9.24-1.92,9.24-1.92S388.88,430.42,376.57,427Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.265px 423.482px"
    },
    id: "elkj9jes9mwle",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.18,413.11a22,22,0,0,0-6.15-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S363.87,416.58,376.18,413.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.49px 409.599px"
    },
    id: "eltzrcj2bdkkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,413.11a22,22,0,0,1,6.15-5.77c3.47-1.92,9.24-1.92,9.24-1.92S388.88,416.58,376.57,413.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.265px 409.599px"
    },
    id: "eliadtbyoxfda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.57,408.11s-3.08-4.14-3.24-8.1,2.45-9.1,2.45-9.1S385.21,398.69,376.57,408.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "376.769px 399.51px"
    },
    id: "el4q2z3vb5hey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444,431.39V408.11a.4.4,0,0,0-.4-.39.39.39,0,0,0-.39.39v23.28Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "443.605px 419.555px"
    },
    id: "elp15bg38t379",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18,427a22.15,22.15,0,0,0-6.16-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S430.87,430.42,443.18,427Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "435.485px 423.482px"
    },
    id: "ellnmpeyyk7em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.56,427a22,22,0,0,1,6.16-5.77c3.46-1.92,9.23-1.92,9.23-1.92S455.87,430.42,443.56,427Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "451.255px 423.482px"
    },
    id: "ellua79tm3y6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.18,413.11a22.15,22.15,0,0,0-6.16-5.77c-3.46-1.92-9.23-1.92-9.23-1.92S430.87,416.58,443.18,413.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "435.485px 409.599px"
    },
    id: "eljjzzd3z03r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.56,413.11a22,22,0,0,1,6.16-5.77c3.46-1.92,9.23-1.92,9.23-1.92S455.87,416.58,443.56,413.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "451.255px 409.599px"
    },
    id: "elhlh89bwxa5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.56,408.11s-3.08-4.14-3.23-8.1,2.44-9.1,2.44-9.1S452.2,398.69,443.56,408.11Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "443.765px 399.51px"
    },
    id: "elm72nigxrrfe",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-74",
    className: "animable",
    style: {
      transformOrigin: "242.365px 432.09px"
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 15.36,
    y1: 432.09,
    x2: 469.37,
    y2: 432.09,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "242.365px 432.09px"
    },
    id: "el3ossb9jont2",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bench--inject-74",
    className: "animable",
    style: {
      transformOrigin: "177.476px 366.59px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.26,375.47a53.81,53.81,0,0,0,.6,41.86L312,431.21a4.27,4.27,0,0,1,.28.88h-5.71l-5-11.31a62.43,62.43,0,0,1-.7-48.53l11.2-27.44a5.95,5.95,0,0,0-5.51-8.19h-25.5c-2.36,0-4.27,2.45-4.27.1a4.27,4.27,0,0,1,4.27-4.27h22a14.46,14.46,0,0,1,12,6.4c2.69,4,3.21,4.71,1.39,9.18Z",
    style: {
      fill: "rgb(163, 163, 163)",
      transformOrigin: "297.156px 382.27px"
    },
    id: "el72n9kczox1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkve52ulfka"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.05,
    y: 309.54,
    width: 3.38,
    height: 122.24,
    style: {
      fill: "rgb(163, 163, 163)",
      transformOrigin: "282.74px 370.66px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elictx6dglwt"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elgi5onuw97je"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 37.43,
    y: 309.54,
    width: 3.38,
    height: 122.24,
    style: {
      fill: "rgb(163, 163, 163)",
      transformOrigin: "39.12px 370.66px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elsrfg26iuel"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el3r6z0gryd56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.33,
    y: 301.09,
    width: 246.79,
    height: 17.75,
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "162.725px 309.965px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elyfna67xouh"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el1wzdidub31t"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.33,
    y: 322.22,
    width: 246.79,
    height: 17.75,
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "162.725px 331.095px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "elp9b12gbjgg"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmafvuwt2okj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.33,
    y: 363.63,
    width: 265.06,
    height: 5.92,
    style: {
      fill: "rgb(189, 189, 189)",
      transformOrigin: "171.86px 366.59px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "el5ck5jnux9sj"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljfk5zikcel"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 39.33,
    y: 363.63,
    width: 42.16,
    height: 5.92,
    style: {
      fill: "rgb(135, 135, 135)",
      transformOrigin: "60.41px 366.59px",
      transform: "rotate(180deg)"
    },
    className: "animable",
    id: "eld4kujesrgdj"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M75.75,344.81a5.95,5.95,0,0,0-5.5-8.19H39.33v-4.17H66.75a14.45,14.45,0,0,1,12,6.4c2.7,4,3.22,4.71,1.39,9.18L69,375.47a53.81,53.81,0,0,0,.6,41.86l6.14,13.88a4.93,4.93,0,0,1,.27.88h-5.7l-5-11.31a62.35,62.35,0,0,1-.7-48.53Z",
    style: {
      fill: "rgb(163, 163, 163)",
      transformOrigin: "60.2745px 382.27px"
    },
    id: "elhxuy5l671jv",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-74",
    className: "animable",
    style: {
      transformOrigin: "240.521px 292.316px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.69,
    cy: 448.59,
    rx: 151.26,
    ry: 11.41,
    style: {
      fill: "#455FC0",
      transformOrigin: "236.69px 448.59px"
    },
    id: "elzlye9zg9vig",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxd76ij78i3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 236.69,
    cy: 448.59,
    rx: 151.26,
    ry: 11.41,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.6,
      transformOrigin: "236.69px 448.59px"
    },
    className: "animable",
    id: "el19kgaplyx8n"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.78,429.56s-2.69,4.71-2.47,7.84,6.5,3.59,7.62,3.14,4.71-9.41,4.26-11.65S248.45,427.54,247.78,429.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "251.263px 434.131px"
    },
    id: "elpjpj3ekgdlq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.64,354.93s1.34,29.81,4,35,12.78,35.41,12.78,35.41l-.67,4.26,2.46.9s4,1.34,6.95-1.57-1.79-41.24-1.79-41.24l-1.12-29.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "244.884px 392.869px"
    },
    id: "el1xe4p6slia3i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.48,430.91a33.24,33.24,0,0,1-2.69,7.39c-1.79,3.36-2.69,6.05,1.8,6.95s12.1,1.34,14.79-.45,1.34-10.31,1.34-10.31S259.43,425.53,252.48,430.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "258.191px 437.612px"
    },
    id: "el2gvgublc29q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.43,443a109.07,109.07,0,0,1-11.06-1.07c-.22,1.59.53,2.77,3.22,3.31,4.48.9,12.1,1.34,14.79-.45.93-.62,1.38-2.07,1.56-3.68A14.62,14.62,0,0,1,259.43,443Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "258.137px 443.567px"
    },
    id: "eluetzp9yg4sj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.91,358.06s-1.12,24.43-1.12,30.49,3.81,36.53,3.81,36.53L252,429.34l.45,1.57v1.34s.67-1.57,5.83-.9S268,437,268,437s1.12-6.5,1.12-8.52-.23-5.16-.23-6.5S270,383.61,270,383.61l4-28.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "261.895px 395.85px"
    },
    id: "elc12jcq5u9bv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.93,340.58l-1.79,12.55s6.05,7.85,23.53,8.74a54,54,0,0,0,30.71-8.29L276,339.91Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "252.26px 350.907px"
    },
    id: "elbz2zamvpg2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,278.28s-9.64,2.91-10.31,4.48-15.92,27.57-15.92,27.57L196.45,305l-1.57,6.27s13.67,13.23,16.59,13.9,15-12.55,15-12.55L224,342.15s6.95,6.05,20.39,6.05,22.64-.89,26.67-2.24a72.56,72.56,0,0,0,6.95-2.69l-4.48-33.17s13,13.45,15.46,13.67,21.69-24.69,21.69-24.69L306.22,293l-17,11.24S276.91,283.43,274,281.19s-10.54-3.36-11.43-3.81S236.35,278.28,236.35,278.28Z",
    style: {
      fill: "rgb(79, 79, 79)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "252.78px 312.744px"
    },
    id: "ele298hkqtfc7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.48,
    y1: 312.57,
    x2: 228.15,
    y2: 295.96,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "227.315px 304.265px"
    },
    id: "el5dvkew1q0wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.55,
    y1: 310.1,
    x2: 271.1,
    y2: 296.21,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "272.325px 303.155px"
    },
    id: "el2br73br66wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.08,313.49c7.8.63,18.34.79,28.27-1.3",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "255.215px 313.049px"
    },
    id: "el37ucr88t5nq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.14,311.94s3.74.75,9.47,1.32",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "233.875px 312.6px"
    },
    id: "el1w517kxvqnt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.94,332.6c.88-.21,1.76-.44,2.66-.68",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "270.27px 332.26px"
    },
    id: "el0i0qrd4fetmi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.64,332.17s14.79,5.66,37.06.93",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "248.17px 333.578px"
    },
    id: "eln4defoagisi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.2,
    y1: 330.65,
    x2: 249.87,
    y2: 341.91,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "250.035px 336.28px"
    },
    id: "elz0h5y5zjqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.12,
    y1: 298.71,
    x2: 250.29,
    y2: 327.46,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "250.705px 313.085px"
    },
    id: "ellbb6k3kox4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.05,271.33s-7.84,3.36-8.51,7.62,4.93,7.39,6.94,9.64,13,9.63,13,9.63,11.66-13.67,13.45-14.56,4.48-5.83,2.69-8.3-9.86-4.93-13-5.6S241.05,271.33,241.05,271.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "250.847px 283.927px"
    },
    id: "elq3rogd7rryd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.84,272.22s1.35,10.76,2.69,13,4.94,9.64,6.06,9.64,4.93-11.88,5.6-13.67,1.12-8.07,1.12-8.07Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "250.575px 283.54px"
    },
    id: "ell0csxl11q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,259a27.93,27.93,0,0,0-9.86,4.71c-4.71,3.58-5.38,13.22-5.38,13.22s2,1.35,7.4-1.57,8.51-7.62,9-11A7.55,7.55,0,0,0,236.57,259Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "229.577px 268.121px"
    },
    id: "elcfhosvbkr0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.1,259a28,28,0,0,1,9.86,4.71c4.7,3.58,5.38,13.22,5.38,13.22s-2,1.35-7.4-1.57-8.52-7.62-9-11A7.55,7.55,0,0,1,263.1,259Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "270.093px 268.121px"
    },
    id: "eledj9mo285p6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,259s-4.26-1.34-3.36,3.36,5.82,6.05,5.82,5.38S236.57,259,236.57,259Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "236.058px 263.362px"
    },
    id: "eljg93w4xjsgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.12,259s4.25-1.34,3.36,3.36-5.83,6.05-5.83,5.38S263.12,259,263.12,259Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "263.626px 263.362px"
    },
    id: "els4pbstsg5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,259s1.34,9.86,3.14,12.55,8.29,7.17,11.2,7.4,8.52-4,10.31-7.17,2.47-19.95,2.47-20.62-.67-5.61-6.73-9.64-16.58-3.14-19.49,2.46S236.57,259,236.57,259Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "249.792px 258.994px"
    },
    id: "elf95xd5sj53b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 244.48,
    cy: 258.86,
    r: 1.45,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.48px 258.86px"
    },
    id: "el9lln5epnz1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 255.79,
    cy: 258.86,
    r: 1.45,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "255.79px 258.86px"
    },
    id: "elfxc64u8x6fw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,265s-2.12,1.46-5.72.13",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "250.66px 265.345px"
    },
    id: "ellb9i9b9dsi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.87,268.43s1.6,2.13,6,1.73,6.13-2.8,6.13-2.8",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "250.935px 268.785px"
    },
    id: "el67qnt1aqntu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,254.85a5.29,5.29,0,0,1,4.26-1.86",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "243.13px 253.918px"
    },
    id: "el75cch0tvrj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.52,253.12a7,7,0,0,1,5.46,2",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "256.25px 254.11px"
    },
    id: "elt3oy06iswh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.57,259s1.12-1.79,3.14-4.93,5.6-9.64,5.6-9.64,5.16,6,9.19,7.4a52.4,52.4,0,0,1,6.27,2.46s.35,4.71,1.35,4.71,5.15-7.39,5.15-13.89-13-15.47-22-12.11-13.67,9.19-13.67,14.57S236.57,259,236.57,259Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "249.435px 245.635px"
    },
    id: "els9utgxyss0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,292.84v7s2,4.93,2,6.5-2.69,9.19-2.91,10.76-2.47,1.12-2.47.22a61.37,61.37,0,0,0,0-6.72c-.22-3.14-3.58-1.34-3.58-1.34s.45,6.94,1.34,8.74a4.78,4.78,0,0,1,.42,1.24A1.62,1.62,0,0,1,84,320.78a.79.79,0,0,1-.23-.37c-.23-.89-6.5-4.48-6.73-5.38a82.35,82.35,0,0,1,0-10.53c.23-2.91,3.59-12.78,3.81-13.45a21.3,21.3,0,0,1,1.12-2.24S91.34,287.91,91.78,292.84Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "85.3258px 304.928px"
    },
    id: "el0dzxv66v7y8h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "78.22 308.93 78.83 315.12 83.37 319.45 80.28 311.41 80.07 307.7",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "80.795px 313.575px"
    },
    id: "elcbz8aqraa3k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.85,186.16s-4,.67-4.93,6.05-3.14,47.29-3.14,47.29L79,292.17s.22-1.79,6.72-1.12,6.5,3.36,6.5,3.36l11-35.18,4.25-13L103,185.49Z",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "93.235px 239.95px"
    },
    id: "el792b32ey1pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.61,426.65a26.08,26.08,0,0,1-6.05,7.84c-3.81,3.14-8.29,5.83-7,9.41s7.4,2.69,11,1.8,6.73-3.36,8.3-4.26a30.76,30.76,0,0,0,4.48-4l.67-10.75Z",
    style: {
      fill: "rgb(79, 79, 79)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "135.672px 436.572px"
    },
    id: "el2wosbb37nya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.44,438.53a30.55,30.55,0,0,1-12.11,5.82,7.07,7.07,0,0,1-6.91-2.36,3.54,3.54,0,0,0,.19,1.91c1.35,3.59,7.4,2.69,11,1.8s6.73-3.36,8.3-4.26a30.76,30.76,0,0,0,4.48-4l.13-2.17A59.69,59.69,0,0,0,142.44,438.53Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "135.443px 440.884px"
    },
    id: "el5vqlpsn7d58",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.23,431.13s-.67,15.24,0,16.14,4,1.57,4.93,2.24.45,2.24,5.16,3.14,13.89,2.46,14.12-4-8.3-12.55-8.3-12.55l-.45-4.48Z",
    style: {
      fill: "rgb(79, 79, 79)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "156.188px 442.311px"
    },
    id: "elbsewnxb732k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.4,449a7.52,7.52,0,0,1-6,2.51c-5.82-.22-12.1-3.81-12.1-3.81l-6.32-3a8.09,8.09,0,0,0,.27,2.54c.67.89,4,1.57,4.93,2.24s.45,2.24,5.16,3.14S167.82,455,168.4,449Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "156.184px 449.082px"
    },
    id: "ela4bx79am68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.76,302c-2.46-19-3.36-26.22-3.36-26.22l-56.25.9s-4.26,34.51-3.37,49.08,1.35,37.88,5.16,43.71,18.83,40.34,20.84,43.7,4,7.4,3.59,10.76a9.21,9.21,0,0,0,.9,5.6l9,1.57.67,1.57s4.26.45,7.62.45,7.62-.23,7.62-.23a52.24,52.24,0,0,0,.68-5.83c0-1.79-.23-6.49-.23-6.49s5.6-27.8,5.38-41.24.67-25.11,1.34-33.62S170.23,321.08,167.76,302Zm-30.48,71.28a64,64,0,0,0-4-12.78l4-46.62,2,.23s1.57,43,1.57,50.42,2.91,48.19,2.91,48.19S138.4,379.58,137.28,373.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "136.779px 354.45px"
    },
    id: "elh4s7nmcstw4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.68,294.86s-2,7.17-2,10.31,3.81,7.85,3.81,7.85,1.57,1.34,1.57-1.35,1.9.56,1.9.56-2.57,2.58,1.24,3.7,9.63-3.36,10.53-5.38-3.36-14.79-3.81-16.36a12.84,12.84,0,0,0-1.79-3.36S185.92,288.81,183.68,294.86Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "191.267px 303.307px"
    },
    id: "elmtltvybhtyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.53,304.4v3.38a3.51,3.51,0,0,1-.93,2.38c-1.53,1.66-4.5,4.75-5.25,4.75",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "192.44px 309.655px"
    },
    id: "elpj5cmqm63ul",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.24,305.84s.21,3.09-1.23,5-4.54,5.36-5.57,5.36",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "195.845px 311.02px"
    },
    id: "elvvfr17p6lk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.94,312.23s1.68-3.7,3.25-4.59-1.12-5.16-2.46-5.38a4.1,4.1,0,0,0-4,4v3.36S188.26,311.56,188.94,312.23Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "189.199px 307.245px"
    },
    id: "elsykh9uh2b3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69,185.94s10.54,3.36,11.21,8.07,2,49.75,2,49.75l.22,6.28,10.09,43.25a31,31,0,0,0-7.85-.89c-3.36.22-5.15,4-5.15,4s-17-36.31-17-41.24S172.69,185.94,172.69,185.94Z",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "181.21px 241.17px"
    },
    id: "el3i3fcz5w19v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.52,172.27s-29.58,11-30.7,14.34S107.7,281,107.7,281a111.17,111.17,0,0,0,24,3.36c13.67.45,32.95-3.59,32.95-3.59s5.37-63.65,6.5-72.17,2.68-14.56,1.12-19.72S153.64,174.06,148.71,172A11.61,11.61,0,0,0,139.52,172.27Z",
    style: {
      fill: "rgb(79, 79, 79)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "140.315px 227.788px"
    },
    id: "eljwrcdkjvqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.94,216.19s-4.26,49.54-4.26,54,9,38.1,9,38.1-15,4.93-15.69,1.34-5.38-52.44-6.5-68.8-1.79-59.62-1.79-59.62-1.12-6,.22-5.83,14.8,9.64,18.38,11.66a10.69,10.69,0,0,1,4.71,5.15",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "167.471px 243.158px"
    },
    id: "eljfv8n2rwuko",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,160.83s-1.57,13.45-1.57,17,4.48,11,10.54,11.88,11.2-7.4,11.43-8.74-18.83-22.86-18.83-22.86Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "148.266px 173.943px"
    },
    id: "elnvzgsu66x6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,147.75a209.17,209.17,0,0,1-4.77,23.6c-3,10.8-3.77,12.31-9.79,13.56s-11.81-2.51-15.82-7.53-4.77-13.56-4.77-13.56l-2.26-3.77-1.26-2.51s-.5-14.56,1.26-21.84,7.28-12.31,22.34-10.8,19.09,11.55,18.84,16.32A7.75,7.75,0,0,1,175.75,147.75Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "158.273px 154.892px"
    },
    id: "el2p47zwe7xv4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,158.3s-1-4.78-4.27-4.52-2.76,6.27-.5,9.54,4.27-.76,4.27-.76",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "138.803px 159.185px"
    },
    id: "ellqu349jv62p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.52,141.22c.25-4.77-3.77-14.81-18.84-16.32s-20.59,3.51-22.34,10.8c-1.22,5-1.35,13.53-1.32,18.31,1.56-.35,3.4-.45,4.08.77,1,1.88.18,7.07-.14,11.51.52,2.91,1.75,7.77,4.41,11.09,4,5,9.79,8.79,15.82,7.53,5.58-1.16,6.64-2.55,9.16-11.33a10.05,10.05,0,0,0-6.9-4c-5.28-.51-13.31,3.51-13.31,3.51s-3.52-2.51-4.77-5.52-1.26-10.05-.51-12.06,2-1.75,3.52-4.77,0-5.27,2.76-8,8-2.76,11.8,0a19.17,19.17,0,0,0,4,2.24,13.17,13.17,0,0,0,5.66.91l2.61-.14.5,2A7.75,7.75,0,0,0,179.52,141.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "158.274px 154.892px"
    },
    id: "eldw86doi541p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.71,158.8s1,7.78-.75,10.29-3.77,1.76-4.27.25l-.5-1.5",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "164.092px 164.764px"
    },
    id: "elbxg6vghgsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.2,173.61s-4,1.76-9.29-1.75",
    style: {
      fill: "none",
      stroke: "rgb(166, 166, 166)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "160.555px 172.956px"
    },
    id: "el3las1cyuknf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,159.77c-.21.94-.82,1.62-1.36,1.5s-.81-1-.61-1.93.82-1.62,1.36-1.51S159.86,158.82,159.66,159.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "158.675px 159.551px"
    },
    id: "eljp6l6metc2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.48,161.64c-.17,1-.75,1.65-1.3,1.55s-.85-.95-.68-1.9.75-1.65,1.3-1.56S170.65,160.68,170.48,161.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "169.49px 161.461px"
    },
    id: "eljvr8glo55ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,155.49a7.93,7.93,0,0,1,6.83.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      transformOrigin: "158.415px 155.208px"
    },
    id: "elm3k07i82y9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,156.77s4.13-.43,5.69,1.56",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      transformOrigin: "170.055px 157.53px"
    },
    id: "ely78qiq17bxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.53,
    cy: 159.47,
    r: 4.55,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "158.53px 159.47px"
    },
    id: "el0qb9jno6q3l8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.75,161.61a4.56,4.56,0,1,1-4.55-4.56A4.55,4.55,0,0,1,175.75,161.61Z",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "171.19px 161.61px"
    },
    id: "el8wws8p3opyw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.8,158.76s3.12-.25,4.41,1.14",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "165.005px 159.321px"
    },
    id: "el9f5n8zae0vr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153.98,
    y1: 158.19,
    x2: 141.1,
    y2: 154.78,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "147.54px 156.485px"
    },
    id: "elpzjovb5pigq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.2,198.94l4.26,48.41s-.23,11-.68,14.57-6.72,37.42-6.72,37.42l14.34,6.73s13.9-55.81,15-66.79,4.93-65,4.93-65S101,184.59,99.85,186.16s-.45,4.26-.45,4.26",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "115.195px 240.175px"
    },
    id: "el9r8nkfjnx0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.08,426.43s-2,10.36-3.27,15.4-3.68,8.72-.82,10.35,10.09,2.18,13.22.55,2.45-7.5,2.45-12.4a105,105,0,0,0-1-11.72Z",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "370.185px 440.071px"
    },
    id: "elr4qo6ecciyi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,447.78c-2,2.13-5.17,4.47-9.49,3.72-4.63-.8-6.34-2.88-7-4.23-.67,2.26-.84,4,.85,4.91,2.86,1.64,10.09,2.18,13.22.55C377.77,451.91,378.38,450.05,378.61,447.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "370.126px 450.492px"
    },
    id: "elfcg1pguaqte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.69,420.44s-2.58,9.26-4.08,12.4-4.36,6.26-3.82,8,5.18,3.68,10.22,2.46,7.22-7.63,7.49-9.81,1.5-4.09,2.86-7.36-.81-6.4-2.45-8.72S342.69,420.44,342.69,420.44Z",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "345.256px 430.254px"
    },
    id: "elibbbkqptori",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.41,434.06c-1.36,3.68-3.81,7.09-8.31,7.77-4.13.62-7.57-2.2-8.1-2.66a2.72,2.72,0,0,0-.21,1.7c.55,1.78,5.18,3.68,10.22,2.46s7.22-7.63,7.49-9.81,1.5-4.09,2.86-7.36a6.06,6.06,0,0,0-.08-4.66C352.51,424.92,352.76,430.42,351.41,434.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "345.262px 432.608px"
    },
    id: "el1qn8cj0nj7w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,285.45s-3.88,29.28-4.78,45.72,1.2,35.86,2.69,39.15,13.45,45.12,14.35,46.61.3,4.79,3,5.68,8.37-.6,10.17-4.78l-.3-9-1.8-4.79s-.59-25.4-3.28-33.17A100.77,100.77,0,0,0,345,360.75l10.76-43s3.29,46.92,5.68,52.6,3.28,40.94,4.48,46.61a56.93,56.93,0,0,1,1.19,10.46,10.52,10.52,0,0,0,6.58,2.1h4.18s4.19-29.59,5.68-37.36-1.79-28.09-1.19-34.36-.3-12.85.29-17.34,5.38-35.56,5.68-41.24a107,107,0,0,0-.3-12.55Z",
    style: {
      fill: "rgb(79, 79, 79)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "356.114px 357.487px"
    },
    id: "eln91nyulmd6b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.65,196.1a34.47,34.47,0,0,0-13.58-2.66c-8,0-21.5,2.68-23.4,3.6S332,291.43,332,291.43s14.11,8,23.17,6.65,21-5.85,21-5.85l-.53-93.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "354.085px 245.836px"
    },
    id: "elsie5l3fp9j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.15,138.71s-11.4,6.33-12.87,14.77,4,10.25,3.92,13.29-9.06,20-7.48,25.07,20.85,13,36.62,11.42,27.69-6.95,28.47-16.13-8.86-16-9.2-18.95,6.92-12.08,1.79-20-25.35-15.32-30.53-14.74S340.15,138.71,340.15,138.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "356.194px 168.436px"
    },
    id: "elfp5735rore",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,190.51l19.7,9.05L386,243.77l9.06,60.7s-11.45,4.8-21.3,5.86c0,0-4.53-34.08-4.53-43.93s1.07-70.56,1.07-70.56v-5.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "382.145px 250.42px"
    },
    id: "el7ts87fk880l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.68,191.76s-24.65,4-25.55,7.62-4,49.76-4,49.76a77.73,77.73,0,0,0-2.51,31.58s7.2-3.76,11.27,1.56c0,0-1.87,21-.93,22.25s15.66,6.89,15.66,6.89,4.7-73,4.7-84.89S341.68,191.76,341.68,191.76Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "325.342px 251.59px"
    },
    id: "elv7bnwddxcdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "321.33 222.46 325.86 247.23 320.87 282.29",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "323.365px 252.375px"
    },
    id: "el0dbmnmzysouj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.41,198.49s5.44,1.78,7.74,6.13c1,1.9,7.46,41.28,8,45.8s-9.32,37.28-9.32,37.28-4.26-3.2-6.12-3.46A29.79,29.79,0,0,0,385,284s1.86-31.42,2.13-32.22.21-29.3.21-29.3",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "394.586px 243.095px"
    },
    id: "elfs9ml7tw9p5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.7,251.22s6.39-3.19,9.85-.8",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "393.625px 250.376px"
    },
    id: "ely6zgo0r1tdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,284s-4.26,9.06-4.26,11.45.53,6.66.53,8.52,2.66,1.33,2.66,1.33,0,4.8,2.13,4.53,3.2-3.46,5.06-5.06,4.8-6.12,4.8-8.79a63.69,63.69,0,0,0-1.07-8.25S391.36,282.11,385,284Z",
    style: {
      fill: "rgb(207, 207, 207)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "388.33px 296.726px"
    },
    id: "elxvozcnkm5pc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 383.9,
    y1: 305.27,
    x2: 383.9,
    y2: 297.29,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "383.9px 301.28px"
    },
    id: "elhkztysd2kj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "386.63 309.62 387.82 308.13 389.16 299.65",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "387.895px 304.635px"
    },
    id: "el3uz1gis9t3v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 390.65,
    y1: 305.31,
    x2: 392.28,
    y2: 299.66,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "391.465px 302.485px"
    },
    id: "eljkzg2xhao3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.91 198.04 346.9 246.2 358.54 249.21 357.94 199.05 348.91 198.04",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "352.72px 223.625px"
    },
    id: "elf585rpnp8fo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "355.13 202.46 355.13 256.63 369.17 255.03 364.96 200.05 355.13 202.46",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "362.15px 228.34px"
    },
    id: "elhxp0jzfinp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,182s-6.42.41-6.42,2.21-1.81,9.83-.61,12.84,8.23,6,16.66,6,16.65-6.42,17.45-7,1-4,.6-4.82-1.8-8.22-3.81-9.23-14.44.41-17.25.61A29.17,29.17,0,0,1,345.7,182Z",
    style: {
      fill: "#455FC0",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "355.92px 192.345px"
    },
    id: "elzhkcu2htqsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.5,181.19s-.41,4.22,1.6,6.22,12.84.6,15.85-2.2,2.21-7.23,2.21-7.23S351.72,183,345.5,181.19Z",
    style: {
      fill: "rgb(207, 207, 207)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "355.361px 183.166px"
    },
    id: "elv4zpgjq0lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.37,146.48s-4.09,6.86-6.56,9.44a28,28,0,0,0-3.29,3.92s.91,13.45,3.38,18,7.09,8.51,13.42,7.41,11.43-7.92,11.6-11-1.05-13-1.05-13S349.06,158.25,346.37,146.48Z",
    style: {
      fill: "rgb(207, 207, 207)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "350.728px 165.958px"
    },
    id: "els0ob6t0budl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.15,160.63a30,30,0,0,0,.45,4.6c.31.77-2.38,4.6,0,5.68a11.12,11.12,0,0,0,4.6,1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "347.404px 166.27px"
    },
    id: "elj76btqhy4qr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.41,175.33s1.36,1,5.36.65,5.54-2.41,5.54-2.41",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "349.86px 174.812px"
    },
    id: "elh5zckahgjy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.34,163.67c.11.77-.2,1.45-.7,1.52s-1-.5-1.09-1.26.2-1.45.7-1.52S342.23,162.9,342.34,163.67Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "341.448px 163.8px"
    },
    id: "elhozy8ba3usd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353,162.15c.11.77-.2,1.45-.69,1.52s-1-.5-1.09-1.26.2-1.45.69-1.52S352.85,161.38,353,162.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "352.113px 162.28px"
    },
    id: "el381rj3n21gq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,160.83a3.69,3.69,0,0,1,4.94-.91",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "340.55px 160.087px"
    },
    id: "el3saftda9yju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.47,159.9s3-4.29,7.78-.91",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "351.36px 158.796px"
    },
    id: "elymlfs2abk5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.59,280.72l-2,6.4s-1.49,4.57-1.36,5.91,4,6.8,7.13,8.68,7.83,0,8.77-1.57-.63-5.64-.63-5.64,2.19-3.13,2.51-4.7-3.14-7.52-3.14-7.52S317.11,276,309.59,280.72Z",
    style: {
      fill: "rgb(207, 207, 207)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "315.126px 290.729px"
    },
    id: "ely0ieq4pd9da",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "321.66 300.85 318.24 299.21 314.97 291.18",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "318.315px 296.015px"
    },
    id: "elce61ng4syse",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.81,292.07s2.08,6.69,3.56,8a12.37,12.37,0,0,0,4.17,2.08",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "314.675px 297.11px"
    },
    id: "elyz2xaqsgveo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.13,292.82a24.87,24.87,0,0,0,2.57,6.26",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "309.415px 295.95px"
    },
    id: "el14nwyzmkq1f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,293.55l-1.6-5s2.41-.4,4.21,2.82a6.83,6.83,0,0,1,.2,6.22l-1.2.61Z",
    style: {
      fill: "rgb(166, 166, 166)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "321.932px 293.367px"
    },
    id: "elt0n188l1cz",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentChild);
export default __webpack_public_path__ + "static/media/ParentChild.162bbbdbb6f2e56e70f0e07ab709232b.svg";
export { ForwardRef as ReactComponent };